import React from 'react';
import { Redirect } from 'react-router';
import { Link, NavLink, withRouter } from 'react-router-dom';
import {
    Form, FormGroup, Label, Input, FormText, Badge, Modal,
    ModalHeader, ModalBody, Button
} from 'reactstrap';
import { signupUser } from '../redux/ActionCreator';
import { TNC } from './TermsAndConditions';

const maxLength = (val) => !(val) || (val.length <= 3);
const minLength = (val) => (val) && (val.length >= 16);
const maxLengthRefCode = (val) => !(val) || (val.length <= 0);
const minLengthRefCode = (val) => (val) && (val.length > 4);
const validEmail = (val) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(val);


class Signup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            gender: "",
            email: "",
            password: "",
            tncCheck: 0,
            checkBox: false,
            refCode: "",

            // Send Input Button text
            buttonText: "Sign Up",
            buttonDisable: false,

            // error Messages
            errorName: " ",
            errorEmail: " ",
            errorPassword: " ",
            errorGender: " ",
            errorLogin: "",
            errorTNC: "",
            errRefCode: "",

            // visibility
            divSuccess: "none",
            divForm: "",

            // modal visibility
            isModalOpen: false,
            isModalOpenWhyWeNeedYou: false
        }
    }

    mySubmitHandler = (event) => {
        event.preventDefault();
        // console.log(this.state);
        // this.setState({password:""});
        if (!validEmail(this.state.email)) {
            this.setState({ errorEmail: "Invalid Email" });
        }
        else {
            this.setState({ errorEmail: "" });

        }
        if (minLength(this.state.name) || maxLength(this.state.name))
            this.setState({ errorName: "Require 4-15 length Name" });
        else {
            this.setState({ errorName: "" });

        }
        if (this.state.gender === "")
            this.setState({ errorGender: "Require Gender. Please select" });
        else {
            this.setState({ errorGender: "" });

        }
        if (maxLength(this.state.password)) {
            this.setState({ errorPassword: "Require 4 or greater length of Password" });
        }
        else {
            this.setState({ errorPassword: "" });
        }
        if (minLengthRefCode(this.state.refCode)) {
            this.setState({ errRefCode: "Max Length is 4" });
        }
        else {
            this.setState({ errRefCode: "" });
        }
        if (this.state.errorEmail === "") {
            if (this.state.errorGender === "") {
                if (this.state.errorName === "") {
                    if (this.state.errorPassword === "" && this.state.errRefCode === "") {
                        var info = {
                            name: this.state.name,
                            username: this.state.email.toLowerCase(),
                            gender: this.state.gender === 'Male' ? false : true,
                            password: this.state.password,
                            refCode: this.state.refCode
                        };
                        this.setState({
                            buttonDisable: true,
                            buttonText: "Sending..."
                        })
                        signupUser(info)
                            .then((resp) => {
                                if (resp) {
                                    // console.log(resp);
                                    if (resp.success) {
                                        this.setState({
                                            divSuccess: "",
                                            divForm: "none"
                                        });
                                        setTimeout(() => {
                                            this.props.history.push('/login');
                                        }, 3000);
                                    }
                                    else {
                                        this.setState({
                                            errorLogin: resp.message,
                                            buttonDisable: false,
                                            buttonText: "Submit"
                                        });
                                    }
                                }
                                else {
                                    this.setState({
                                        errorLogin: "Cannot reach Server. Please Try Again.",
                                        buttonDisable: false,
                                        buttonText: "Submit"
                                    })
                                }
                            })
                    }
                }
            }
        }
    }

    myChangeHandler = (event) => {
        // console.log(event.target)
        let nam = event.target.name;
        let val = event.target.value;
        // console.log(nam,val)
        this.setState({ [nam]: val });
        if (nam === "email") {
            if (!validEmail(val)) {
                this.setState({ errorEmail: "Invalid Email" });
            }
            else {
                this.setState({ errorEmail: "" });
            }
        }
        else if (nam === "name") {
            if (minLength(val) || maxLength(val))
                this.setState({ errorName: "Require 4-15 length Name" });
            else {
                this.setState({ errorName: "" });
            }
        }
        else if (nam === "gender") {
            if (val === "")
                this.setState({ errorGender: "Require Gender. Please select" });
            else {
                this.setState({ errorGender: "" });
            }
        }
        else if (nam === "password") {
            if (maxLength(val)) {
                this.setState({ errorPassword: "Require 4 or greater length of Password" });
            }
            else {
                this.setState({ errorPassword: "" });
            }
        }
        else if (nam === "refCode") {
            if (minLengthRefCode(val)) {
                this.setState({ errRefCode: "Max Length is 4" });
            }
            else {
                this.setState({ errRefCode: "" });
            }
        }
    }

    validate = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        // console.log(nam)
        if (nam === "email") {
            if (!validEmail(this.state.email)) {
                this.setState({ errorEmail: "Invalid Email" });
            }
            else {
                this.setState({ errorEmail: "" });
            }
        }
        else if (nam === "name") {
            if (minLength(this.state.name) || maxLength(this.state.name))
                this.setState({ errorName: "Require 4-15 length Name" });
            else {
                this.setState({ errorName: "" });
            }
        }
        else if (nam === "gender") {
            if (this.state.gender === "")
                this.setState({ errorGender: "Require Gender. Please select" });
            else {
                this.setState({ errorGender: "" });
            }
        }
        else if (nam === "password") {
            if (maxLength(this.state.password)) {
                this.setState({ errorPassword: "Require 4 or greater length of Password" });
            }
            else {
                this.setState({ errorPassword: "" });
            }
        }
        else if (nam === "refCode") {
            if (minLengthRefCode(val)) {
                this.setState({ errRefCode: "Max Length is 4" });
            }
            else {
                this.setState({ errRefCode: "" });
            }
        }
    }

    toggleModal = () => {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    toggleModalWhyWeNeedYou = () => {
        this.setState({
            isModalOpenWhyWeNeedYou: !this.state.isModalOpenWhyWeNeedYou
        });
    }

    handleCheckBox = (event) => {
        this.setState({
            checkBox: !this.state.checkBox
        })
    }

    render() {
        if (this.props.user.isAuthenticated) {
            return (
                <Redirect to="/dashboard" />
            );
        }
        return (
            <div className="container">
                <div className="row justify-content-center" style={{ display: this.state.divForm }}>
                    <Form onSubmit={this.mySubmitHandler}>
                        <FormGroup >
                            <Label className="required" for="name">Name</Label>
                            <Input
                                id="name"
                                type='text'
                                name='name'
                                onChange={this.myChangeHandler}
                                value={this.state.name}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errorName}</FormText>
                        </FormGroup>
                        <FormGroup className="mt-100">
                            <Label className="required" for="email">Email</Label>
                            <Input
                                id="email"
                                type='text'
                                name='email'
                                onChange={this.myChangeHandler}
                                value={this.state.email}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errorEmail}</FormText>
                        </FormGroup>
                        <FormGroup>
                            <Label className="required" for="exampleSelect">Gender</Label>
                            <Input
                                type="select"
                                name="gender"
                                id="gender"
                                onChange={this.myChangeHandler}>
                                <option defaultValue hidden>Choose here</option>
                                <option>Male</option>
                                <option>Female</option>
                            </Input>
                            <FormText color="danger">{this.state.errorGender}</FormText>
                        </FormGroup>
                        <FormGroup>
                            <Label className="required" for="password">Password</Label>
                            <Input
                                id="password"
                                type={this.state.checkBox ? "text" : "password"}
                                name='password'
                                onChange={this.myChangeHandler}
                                value={this.state.password}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errorPassword}</FormText>
                        </FormGroup>
                        <FormGroup>
                            <Label for="password">Have Referal Code?</Label>
                            <Input
                                id="refCode"
                                type="text"
                                name='refCode'
                                onChange={this.myChangeHandler}
                                value={this.state.refCode}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errRefCode}</FormText>
                        </FormGroup>
                        <div>
                            <input
                                type="checkbox"
                                checked={this.state.checkBox}
                                onChange={this.handleCheckBox}
                            />
                            <label>Show Password</label>
                        </div>
                        <FormGroup style={{ margin: 0 }}>
                            <small for="tnc">By clicking Sign Up, you agree to our<br />
                                <a
                                    href="javascript:void(0);"
                                    onClick={() =>
                                        this.setState({
                                            isModalOpen: !this.state.isModalOpen
                                        })
                                    }>Terms and Conditions</a></small>
                        </FormGroup>
                        <input
                            type='submit'
                            value={this.state.buttonText}
                        />
                        <div className="mt-2">
                            <FormGroup>
                                <h6>Already a member: <Link to="/login">Login</Link></h6>
                            </FormGroup>
                        </div>
                        <div>
                            <Button color="primary" onClick={this.toggleModalWhyWeNeedYou}>Why We Need Your Voice?</Button>
                        </div>
                    </Form>
                </div>

                <div className="row justify-content-center">
                    <FormText color="danger">{this.state.errorLogin}</FormText>
                </div>

                <div className="mt-3" style={{ display: this.state.divSuccess }}>
                    <h4><Badge color="success">Account Successfully created for email {this.state.email}</Badge></h4>
                    <h5>Redirecting to login page in 3 seconds. Or Click <NavLink to="/login">Here</NavLink></h5>
                </div>
                <div className="mt-3">
                    <h5><Badge color="success">{this.state.errorServer}</Badge></h5>
                </div>

                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Terms And Conditions</ModalHeader>
                    <ModalBody>
                        <TNC />
                        <Button
                            onClick={() => {
                                this.setState({
                                    isModalOpen: !this.state.isModalOpen
                                })
                            }}
                        >Close</Button>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isModalOpenWhyWeNeedYou} toggle={this.toggleModalWhyWeNeedYou}>
                    <ModalHeader toggle={this.toggleModalWhyWeNeedYou}><Badge color="primary">Why do we need your Voice?</Badge></ModalHeader>
                    <ModalBody>
                        <div className="row m-auto">
                            <div>
                                <h5 className="changeFont"><Badge color="success">Hi, This is a Live Project.</Badge></h5>
                                <h5 className="changeFont">The goal is to build a software which will take in Hindi Audio/Video and generate Hindi Text.</h5>
                                <h5 className="changeFont">Like a teacher will give us her 1 hour video and we will generate the notes in 1 minute.</h5>
                                <h5 className="changeFont">To build this we need data. On our website you will recieve a Hindi sentence which you will then Record using the recorder on the website.</h5>
                                <h5 className="changeFont"> To make a good Software we need 500 spoken sentences from each individual. </h5>
                                <h5 className="changeFont"><Badge color="success">Why so Many Voices?</Badge></h5>
                                <h5 className="changeFont">Because we want the Software to <strong>Listen Hindi and then Learn to write.</strong> We could have made a single person speak all the sentence. But then the software will only understand his voice.</h5>
                                <h5 className="changeFont"> To make the Software learn different ways of speaking Hindi we need different poeple to speak these sentences.</h5>
                                <h5 className="changeFont"><Badge color="success">Thank You!</Badge></h5>
                                <h5 className="changeFont">We appreciate you taking out some of your time to help us build this Software. Visit us at <strong>Datastack.ml</strong> using your <strong>Chrome Browser</strong>. Thank You</h5>
                            </div>
                        </div>
                        <Button
                            onClick={() => {
                                this.setState({
                                    isModalOpenWhyWeNeedYou: !this.state.isModalOpenWhyWeNeedYou
                                })
                            }}
                            size="sm"
                        >Close</Button>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default withRouter(Signup);